module.exports = __webpack_public_path__ + "static/video-nfts-foreground-46458c72272ae8dd4aae75443c8c30fc.webp";